export default __webpack_public_path__ + "static/media/character-signup-lookdown.97b53c98.svg";